import { useState } from "react";
import { Plus } from "react-feather";
import { Form, Input, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Href, TaskList, Todo } from "../../../../Constants/Constants";
import CommonHeading from "../Common/CommonHeading";
import AllTodo from "./AllTodo";
import MyToDos from "./MyToDos";

const ToDo = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <div className="todo-main">
      <CommonHeading title={Todo} sunTitle={TaskList} />
      <div className="todo-name">
        <Form className="default-form">
          <Input type="select" className="custom-scroll">
            <option>All Conversations</option>
            <option>Josephin water</option>
            <option>Jony Lynetin</option>
            <option>Sufiya Elija</option>
            <option>Mukrani Pabelo</option>
            <option>Jhon Deo</option>
          </Input>
        </Form>
      </div>
      <div className="todo-tab template-tab custom-scroll">
        <Nav tabs>
          <NavItem>
            <NavLink className={`button-effect ${activeTab === "all" ? "active" : ""}`} onClick={() => setActiveTab("all")}>
              All
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={`button-effect ${activeTab === "todo" ? "active" : ""}`} onClick={() => setActiveTab("todo")}>
              My to-dos
            </NavLink>
          </NavItem>
          <NavItem>
            <a className="icon-btn btn-light button-effect btn-sm" href={Href} onClick={toggle}>
              <Plus />
            </a>
          </NavItem>
        </Nav>
        <div className="tab-content">
          <TabContent activeTab={activeTab} className="custom-scroll">
            <TabPane tabId="all">
              <AllTodo />
            </TabPane>
            <TabPane tabId="todo">
              <MyToDos modal={modal} toggle={toggle} />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default ToDo;
